
import { Link } from "react-router-dom";
import { servicesData } from "./services/servicesData";
import ServiceCard from "./services/ServiceCard";
import { useEffect, useRef } from "react";

export const ServicesSection = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    // Parallax effect for section
    const handleMouseMove = (e: MouseEvent) => {
      if (!sectionRef.current) return;
      const elements = sectionRef.current.querySelectorAll('.parallax');
      const x = e.clientX / window.innerWidth;
      const y = e.clientY / window.innerHeight;
      elements.forEach(el => {
        const depth = parseFloat(el.getAttribute('data-depth') || '0.1');
        const moveX = (x - 0.5) * depth * 50;
        const moveY = (y - 0.5) * depth * 50;
        el.setAttribute('style', `transform: translate(${moveX}px, ${moveY}px)`);
      });
    };

    // Animate items on load
    const animateItems = () => {
      const items = document.querySelectorAll('.service-animate');
      items.forEach((item, index) => {
        setTimeout(() => {
          item.classList.add('opacity-100', 'translate-y-0');
        }, 200 * index);
      });
    };
    document.addEventListener('mousemove', handleMouseMove);
    animateItems();
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);
  
  return <section id="services" ref={sectionRef} className="relative py-12 flex items-center px-6 overflow-hidden" style={{
    background: 'linear-gradient(180deg, rgba(12,20,39,1) 0%, rgba(17,24,50,0.95) 50%, rgba(12,20,39,1) 100%)'
  }}>
      {/* Background accents */}
      <div className="absolute top-1/3 left-1/4 w-72 h-72 bg-primary/10 rounded-full filter blur-[100px]"></div>
      <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-blue-900/20 rounded-full filter blur-[120px]"></div>
      
      {/* Extended top gradient overlay for smooth transition from previous section */}
      <div className="absolute top-0 left-0 w-full h-40 bg-gradient-to-b from-[#0c1427] via-[#151b31] to-transparent"></div>
      
      {/* Bottom gradient overlay for smooth transition to next section */}
      <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-[#0c1427] to-transparent"></div>

      {/* Content */}
      <div className="container mx-auto relative z-10 max-w-7xl py-6">
        <div className="text-center mb-8">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 tracking-tight service-animate opacity-0 translate-y-4 transition-all duration-700 delay-200">
            <span className="text-gradient">AI</span> <span className="text-white">Consulting Services</span>
          </h2>
          
          <p className="text-lg md:text-xl text-foreground/80 max-w-3xl mx-auto mb-8 service-animate opacity-0 translate-y-4 transition-all duration-700 delay-300">
            Collaborate with our experts to revolutionize your legal practice through innovative AI-driven strategies and insights.
          </p>
        </div>
        
        {/* Services Grid - with links to their subpages */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 service-animate opacity-0 translate-y-4 transition-all duration-700 delay-400">
          {servicesData.slice(0, 4).map((service, index) => (
            <Link 
              key={service.id} 
              to={
                service.title === "Strategy Consulting" 
                  ? "/services/strategy" 
                  : service.title === "Custom Workflows"
                    ? "/services/custom-solutions"
                    : `/services/${service.title.toLowerCase().replace(/\s+/g, '-')}`
              }
              className="block h-full transition-transform hover:scale-[1.02] duration-300"
            >
              <ServiceCard 
                title={service.title} 
                description={service.description} 
                icon={service.icon} 
                color={service.color} 
                delay={index * 100} 
              />
            </Link>
          ))}
        </div>
      </div>
    </section>;
};

export default ServicesSection;
